var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "validation", staticClass: "analise", attrs: { tag: "div" } },
    [
      _vm.despacho !== null
        ? _c(
            "div",
            { staticClass: "analise" },
            [
              _vm.despacho.processo !== null
                ? _c(
                    "app-analise-header",
                    {
                      attrs: {
                        "id-processo": _vm.despacho.processo.id,
                        "numero-processo": _vm.despacho.processo.numeroProcesso,
                        statusProcesso: _vm.despacho.processo.status,
                        "titulo-analise": _vm.tipoEmissao,
                        tipo: _vm.despacho.processo.tipo.codigo,
                        numeroProtocolo: _vm.despacho.processo.numeroProtocolo,
                        btnSolicitarInformacao: true,
                        idDespacho: _vm.despacho.id,
                        "show-separate": true,
                        "show-messages": true,
                        opcoesHeader: true,
                        isEmissaoCertidao: true
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "separate" },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "card-collapse",
                              attrs: { shadow: "hover" }
                            },
                            [
                              _vm.dadosCadastro
                                ? _c("app-despachos", {
                                    attrs: {
                                      idProcesso: _vm.idProcesso,
                                      data: _vm.dadosCadastro
                                    },
                                    on: { getDownload: _vm.getDownload }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "analise" },
                        [
                          _vm.showDocumentosConferirTitulo &&
                          !_vm.isRevisaoOuRetorno &&
                          !_vm.isRetornoComissaoIlha
                            ? _c(
                                "div",
                                [
                                  _vm.showDocumentosConferirTitulo
                                    ? _c(
                                        "div",
                                        [
                                          _vm.tipoReurbConferencia
                                            ? _c(
                                                "el-card",
                                                {
                                                  staticClass:
                                                    "shadow-card info-cadastro-ma"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "info-cadastro-ma__titulo"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Informações do cadastro"
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-row",
                                                    {
                                                      staticClass:
                                                        "info-cadastro-ma__dados",
                                                      attrs: { gutter: 16 }
                                                    },
                                                    [
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 8 } },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "info-cadastro-ma__label"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Tipo REURB:"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "info-cadastro-ma__valor"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.labelTipoReurb
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 8 } },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "info-cadastro-ma__label"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Bem único:"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "info-cadastro-ma__valor"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.labelBemUnico
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 8 } },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "info-cadastro-ma__label"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Tipo requerente:"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "info-cadastro-ma__valor"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.labelTipoRequerente
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "app-split-pane",
                                    {
                                      ref: "meuSplit",
                                      staticStyle: { height: "60vh" },
                                      attrs: {
                                        initialLeft: 400,
                                        minLeft: 0,
                                        minRight: 0,
                                        startRightCollapsed: true,
                                        storageKey: "layout-sicarf",
                                        closeVisible:
                                          !!_vm.documentoAberto.src ||
                                          !!_vm.documentoAberto.bytes
                                      },
                                      on: { close: _vm.fecharDocumento }
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "left" },
                                        [
                                          _vm.bytes && !_vm.isRevisaoOuRetorno
                                            ? _c("app-pdf-viewer", {
                                                attrs: {
                                                  bytes: _vm.bytes,
                                                  height: "500",
                                                  hideMiniPages: true
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _c(
                                        "template",
                                        { slot: "right" },
                                        [
                                          _vm.documentoAberto.src
                                            ? _c("app-image-preview", {
                                                ref: "imagePreview",
                                                attrs: {
                                                  src: _vm.documentoAberto.src
                                                },
                                                on: {
                                                  close: _vm.fecharDocumento
                                                }
                                              })
                                            : _vm._e(),
                                          _vm.documentoAberto.bytes &&
                                          !_vm.documentoAberto.isImagem
                                            ? _c("app-pdf-viewer", {
                                                attrs: {
                                                  bytes:
                                                    _vm.documentoAberto.bytes,
                                                  height: "500",
                                                  hideMiniPages: true
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  ),
                                  _c("app-divider", {
                                    attrs: { label: "Documentos" }
                                  }),
                                  _c("el-table", {
                                    attrs: {
                                      data: _vm.documentosValidarTitulo
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "Tipo de documento",
                                                  prop: "tipoDocumento"
                                                }
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "Nome do arquivo:",
                                                  prop: "nomeArquivo"
                                                }
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "Ações",
                                                  prop: "valor",
                                                  width: "85"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "app-action-button",
                                                                {
                                                                  attrs: {
                                                                    icone:
                                                                      "eye",
                                                                    text:
                                                                      "Visualizar Documento",
                                                                    fontSize:
                                                                      "18"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.visualizarDocumento(
                                                                        scope.row
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1118912904
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.bytes &&
                          !_vm.isRevisaoOuRetorno &&
                          !_vm.showDocumentosConferirTitulo
                            ? _c("app-pdf-viewer", {
                                attrs: { bytes: _vm.bytes }
                              })
                            : _vm._e(),
                          _vm.isRevisaoOuRetorno
                            ? _c(
                                "div",
                                [
                                  _c("validation-provider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                staticClass:
                                                  "input-text-editor",
                                                attrs: { label: "Despacho" }
                                              }),
                                              _c("app-editor-texto", {
                                                ref: "editorTexto",
                                                staticClass: "input",
                                                class: { erro: errors.length },
                                                on: {
                                                  onTextChange: _vm.onTextChange
                                                },
                                                model: {
                                                  value:
                                                    _vm.despacho.textoDespacho,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.despacho,
                                                      "textoDespacho",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "despacho.textoDespacho"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2877039618
                                    )
                                  }),
                                  _c("app-anexo", {
                                    attrs: {
                                      id: "upload-anexo-despacho",
                                      files: _vm.despacho.documentos,
                                      tipoExibir: "ANEXO_ANALISE"
                                    },
                                    on: {
                                      uploadFile: _vm.uploadFile,
                                      removeFile: _vm.removeFile,
                                      downloadDocumentoCadastro:
                                        _vm.downloadDocumentoCadastro
                                    }
                                  }),
                                  _vm.isArquivamentoIndeferimento &&
                                  !_vm.isReurbIndividual
                                    ? _c(
                                        "el-card",
                                        [
                                          _c("app-label", {
                                            attrs: {
                                              label:
                                                "Inclua a Carta de Notificação ao Interessado",
                                              required:
                                                _vm.isValidateCarta !== ""
                                            }
                                          }),
                                          _c("validation-provider", {
                                            attrs: {
                                              rules: _vm.isValidateCarta
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c("app-anexo", {
                                                        attrs: {
                                                          id:
                                                            "upload-carta-notificacao",
                                                          files: _vm.cartas,
                                                          showAnexar: true,
                                                          errors: errors,
                                                          tiposArquivosPermitidos:
                                                            _vm.tiposArquivosPermitidosMapas,
                                                          showUpload:
                                                            _vm.cartas
                                                              .length === 0
                                                        },
                                                        on: {
                                                          uploadFile:
                                                            _vm.uploadCartaNotificacao,
                                                          removeFile:
                                                            _vm.removeCartaNotificacao,
                                                          downloadDocumentoCadastro:
                                                            _vm.getDownload
                                                        },
                                                        model: {
                                                          value: _vm.cartas,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.cartas = $$v
                                                          },
                                                          expression: "cartas"
                                                        }
                                                      })
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              87136372
                                            )
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showTextoRetificacao
                            ? _c("h4", { staticClass: "texto-retificacao" }, [
                                _vm._v(
                                  _vm._s(
                                    "Houve uma retificação desse processo neste despacho, analise o título atentamente."
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm.acoesRadio.length > 0 && !_vm.isCertidao
                            ? _c(
                                "div",
                                { staticClass: "extra-margin-top" },
                                [
                                  _c(
                                    "validation-observer",
                                    {
                                      ref: "validationTitulo",
                                      staticClass: "flex-around",
                                      attrs: { tag: "div" }
                                    },
                                    [
                                      _c("app-radios-tramitacao", {
                                        attrs: {
                                          radios: _vm.acoesRadio,
                                          isDecisao: _vm.isDecisao,
                                          radioInicial: _vm.despacho.acao
                                        },
                                        on: { changeRadio: _vm.changeRadio }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "flex extra-margin-top" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "default" },
                                    on: {
                                      click: function($event) {
                                        return _vm.cancelar()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-ban" }),
                                    _vm._v("  Cancelar")
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                !_vm.isRevisaoOuRetorno
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "btn",
                                        attrs: { type: "default" },
                                        on: {
                                          click: function($event) {
                                            return _vm.downloadPdf()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v("Download PDF  "),
                                        _c("i", {
                                          staticClass: "fa fa-download"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.isRevisaoOuRetorno &&
                                !(_vm.isMaranhao && _vm.isReurbIndividual)
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "btn",
                                        attrs: { type: "default" },
                                        on: { click: _vm.editarTituloCertidao }
                                      },
                                      [
                                        _vm._v(
                                          "Editar " + _vm._s(_vm.titulo) + "  "
                                        ),
                                        _c("i", { staticClass: "fa fa-edit" })
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "success" },
                                    on: { click: _vm.finalizar }
                                  },
                                  [
                                    _vm._v("Finalizar  "),
                                    _c("i", { staticClass: "fa fa-check" })
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-097c64ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-097c64ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/ConferenciaTituloCertidao.vue
// module id = null
// module chunks = 